var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _circle, _circle2, _text, _text2, _rect5, _text3, _rect6, _text4, _text5, _rect7, _text6, _rect8, _text7, _text8, _rect9, _text9, _text10, _rect10, _rect11, _path4, _text11, _text12, _text13, _rect12, _circle3, _rect13, _circle4, _rect14, _rect15, _text14, _text15, _rect16, _text16, _text17, _rect17, _text18, _text19, _text20, _text21, _rect18, _text22, _rect19, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatbotPlatform(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 32,
    fill: "#0f1724"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 1152,
    height: 712,
    rx: 28,
    fill: "#142033",
    stroke: "#2f3e54",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 238,
    height: 664,
    rx: 18,
    fill: "#172537",
    stroke: "#32445c",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 74,
    width: 52,
    height: 52,
    rx: 14,
    fill: "#2dd4bf"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 91h14v8H91v-8Z",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h24v15H86V99Z",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87v-5h10v5",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 106,
    r: 2.5,
    fill: "#ffffff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 106,
    r: 2.5,
    fill: "#ffffff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 92,
    fill: "#ffffff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 23,
    fontWeight: 800
  }, "Chatbot Platform")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 122,
    fill: "#a8bdd6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18
  }, "openrouter")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 166,
    width: 190,
    height: 52,
    rx: 9,
    fill: "#101a28",
    stroke: "#40536d"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 199,
    fill: "#91a4bc",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18
  }, "Support copilot")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 240,
    width: 190,
    height: 86,
    rx: 9,
    fill: "#101a28",
    stroke: "#40536d"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 276,
    fill: "#91a4bc",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18
  }, "Set role, tone,")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 303,
    fill: "#91a4bc",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18
  }, "and rules.")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 346,
    width: 190,
    height: 48,
    rx: 10,
    fill: "#2dd4bf"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 377,
    fill: "#ffffff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 19,
    fontWeight: 800
  }, "Create")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 442,
    width: 190,
    height: 72,
    rx: 12,
    fill: "#104d44",
    stroke: "#247b72"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 474,
    fill: "#ffffff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 19,
    fontWeight: 800
  }, "Research bot")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 499,
    fill: "#a8f3e8",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16
  }, "12 chats")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 538,
    width: 190,
    height: 72,
    rx: 12,
    fill: "#172537"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 570,
    fill: "#ffffff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 19,
    fontWeight: 800
  }, "Docs agent")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 595,
    fill: "#a8bdd6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16
  }, "4 chats")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 48,
    width: 834,
    height: 664,
    rx: 18,
    fill: "#111c2c",
    stroke: "#32445c",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 48,
    width: 834,
    height: 124,
    rx: 18,
    fill: "#172537"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M344 82h18v14h-12l-6 6V82Z",
    stroke: "#2dd4bf",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 374,
    y: 98,
    fill: "#2dd4bf",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 800
  }, "CHAT WORKSPACE")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 344,
    y: 138,
    fill: "#ffffff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 38,
    fontWeight: 900
  }, "Research bot")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 844,
    y: 120,
    fill: "#ffffff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 800
  }, "settings")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 83,
    width: 50,
    height: 50,
    rx: 10,
    fill: "#101a28",
    stroke: "#40536d"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 975,
    cy: 108,
    r: 10,
    stroke: "#cbd5e1",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1016,
    y: 83,
    width: 92,
    height: 50,
    rx: 25,
    fill: "#101a28",
    stroke: "#40536d"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 108,
    r: 11,
    stroke: "#cbd5e1",
    strokeWidth: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1066,
    y: 95,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#2dd4bf"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 212,
    width: 394,
    height: 82,
    rx: 12,
    fill: "#172537",
    stroke: "#40536d"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 238,
    fill: "#cbd5e1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 800
  }, "AGENT")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 272,
    fill: "#ffffff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 19
  }, "Upload PDFs, images, or notes into chat context.")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 328,
    width: 512,
    height: 82,
    rx: 12,
    fill: "#123f67",
    stroke: "#1f77ba"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 618,
    y: 354,
    fill: "#d8ecff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 800
  }, "YOU")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 618,
    y: 388,
    fill: "#ffffff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20
  }, "Summarize this reference letter and find the sender.")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 446,
    width: 474,
    height: 118,
    rx: 12,
    fill: "#172537",
    stroke: "#40536d"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 472,
    fill: "#cbd5e1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 800
  }, "AGENT")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 696,
    y: 472,
    fill: "#cbd5e1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 800
  }, "OPENROUTER")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 508,
    fill: "#ffffff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20
  }, "The letter is from the CEO listed in the attached document.")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 540,
    fill: "#a8bdd6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18
  }, "Answer includes markdown, files, workflow state, and retries.")), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 608,
    width: 674,
    height: 62,
    rx: 13,
    fill: "#101a28",
    stroke: "#40536d"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 392,
    y: 647,
    fill: "#91a4bc",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20
  }, "Ask this agent anything...")), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1054,
    y: 608,
    width: 54,
    height: 62,
    rx: 13,
    fill: "#2dd4bf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1074 639l24-14-8 27-6-11-10-2Z",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotPlatform);
export default __webpack_public_path__ + "static/media/chatbot-platform.9e62a7396c338af2b5b6431078319d5b.svg";
export { ForwardRef as ReactComponent };